export const replaceAll = (str, search, replace) => str.split(search).join(replace)
